
import { useState } from "react";
import AnswerAction from "./AnswerAction";
import AnswerContent from "./AnswerContent";
import AnswerOtherAction from "./AnswerOtherActions";
import Form from "./form/Form";

export default function Answer({ answer, onReloadNeeded }) {
	const [isEdit, setIsEdit] = useState(false);

	const handleSuccessEdit = (e) => {
		setIsEdit(false);
		onReloadNeeded();
	}

	return (
		<>
			{answer.is_owner && (
				<>
					<AnswerAction answer={answer} isEdit={isEdit} setIsEdit={setIsEdit} onReloadNeeded={onReloadNeeded} />
					<div className="spacer p-[2px]"></div>
				</>
			)}
			{isEdit ? (
				<Form answer={answer} onSuccess={() => handleSuccessEdit()} />
			) : (
				<AnswerContent answer={answer} />
			)}
			<>
				<AnswerOtherAction answer={answer} />
				<div className="spacer p-[2px]"></div>
			</>
		</>
	)
}
